import { DateRenderer } from '@/components/UI/DateRenderers/DateRenderers';
import { calculateAge } from '@/helpers';
import { _isNotBlank, _notNil } from '@/littledash';
import type { Animal } from '@/model/Animal.model';
import type { TreatmentGroup } from '@/model/TreatmentGroup.model';
import cn from 'classnames';
import { type FC } from 'react';

interface CageCardProps {
  subject: Animal;
  studyGroup?: TreatmentGroup;
  inStudyView?: boolean;
  isDragging?: boolean;
}

const CageCard: FC<CageCardProps> = ({ subject, studyGroup, inStudyView, isDragging = false }) => {
  const { name, dob, sex, catalog, study_id: studyId, number } = subject;
  const groupColor = studyGroup?.color;
  const groupName = studyGroup?.name;

  const style = {
    opacity: isDragging ? 0.8 : 1,
  };

  return (
    <div className="bg-white br2 pa2" style={style}>
      <div className="flex f7 near-black">
        <div
          className={cn('groupColour br3 pa1 mr2', _notNil(groupColor) ? groupColor : 'b--dashed ba')}
          style={{
            backgroundColor: _notNil(groupColor) ? groupColor : '#fff',
          }}
        />

        <div className="flex-grow-1">
          <div className="flex flex-wrap mb1">
            <div className="pa1 mr1 bg-moon-gray br2">{_notNil(studyId) ? number : catalog}</div>
            <div className="pa1 fw5">{name}</div>
            <div className="pa1 flex flex-grow-1 justify-end fw5">{_isNotBlank(sex) ? sex.toUpperCase() : '-'}</div>
          </div>
          <div>
            {_notNil(dob) ? (
              <>
                <DateRenderer value={dob} /> ({calculateAge(dob)})
              </>
            ) : (
              '-'
            )}
          </div>
          <div className="mt1">{_isNotBlank(groupName) ? groupName : inStudyView === true ? '-' : ' '}</div>
        </div>
      </div>
    </div>
  );
};

export default CageCard;
